import getTheme from './get-theme'
const theme = getTheme()
const config = require(`@/assets/themes/${theme}/config.js`)
if (!config.calendarColor) {
  // see calendar colors here: https://vcalendar.io/colors-dark-mode.html
  config.calendarColor = 'gray'
}

export default config
